import '@babel/polyfill';
import 'popper.js';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/tab';
import LazyLoad from 'vanilla-lazyload';
import { sponsorsCarousel, feedCarousel, teamCarousel, aboutCarousel } from './components/carousels';
import VueApps from './VueApps';
import Nav from './components/navigation';
import Forms from './components/forms';
import InstagramFeed from './components/instagram-feed';

class App {
  static init() {
    (new Nav()).init();
    VueApps();
    teamCarousel();
    feedCarousel();
    sponsorsCarousel();
    aboutCarousel();
    (new Forms()).init();
    (new InstagramFeed().init());

    $(() => {
      const elementsToLazyLoad = document.querySelectorAll('img.lazy, div.lazy, a.lazy');
      // eslint-disable-next-line
      const lazy = new LazyLoad({}, elementsToLazyLoad);
    });

    if ([...document.querySelectorAll('.js-time-ago')].length) {
      (async () => {
        const module = await import('dayjs');
        const plugin = await import('dayjs/plugin/relativeTime');
        const dayjs = module.default;
        const relativeTime = plugin.default;
        dayjs.extend(relativeTime);
        [...document.querySelectorAll('.js-time-ago')].forEach((item) => {
          const timer = item;
          timer.innerText = dayjs(item.dataset.time).fromNow();
        });
      })();
    }
    if ([...document.querySelectorAll('.js-replace-hashtags')].length) {
      [...document.querySelectorAll('.js-replace-hashtags')].forEach((item) => {
        const link = item;
        const url = link.dataset.type;
        link.innerHTML = link.innerHTML.replace(/[<]br[^>]*[>]/gi,"");
        link.innerHTML = link.innerHTML.replace(/#(\S+)/g, `<a href='${url}hashtag/$1' target="_blank">#$1</a>`);
      });
    }

    if ([...document.querySelectorAll('.js-scroll-top')].length) {
      const scrollTop = () => {
        import('smooth-scroll').then(module => {
          const SmoothScroll = module.default;
          (new SmoothScroll()).animateScroll(0);
        });
      };
      [...document.querySelectorAll('.js-scroll-top')].forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          scrollTop();
        });
      });
    }
    $('a[data-toggle=tab]').each(function click() {
      const $this = $(this);

      $this.on('shown.bs.tab', () => {
        import(/* webpackChunkName: "js/masonry" */ 'masonry-layout').then(Masonry => {
          this.Masonry = Masonry.default;
          [...document.querySelectorAll('.testimonials .grid')].forEach((item) => {
            // eslint-disable-next-line
            new this.Masonry(item, {
              itemSelector: '.grid-item',
              columnWidth: '.grid-sizer',
              percentPosition: true,
            });
          });
        });
      });
    });
  }
}

App.init();
